// extracted by mini-css-extract-plugin
export var displayNone = "_kr-6";
export var imgContainer = "_kr-2";
export var overflowHidden = "_kr-3";
export var productInfoCardButtonContainer = "_kr-5";
export var productTitleText = "_kr-4";
export var rightArrow = "_kr-1";
export var rightArrowContainer = "_kr-0";